/**
 * Per-request routing for SiteInformationQuery, resolved before the frontend Statsig client exists.
 * Relay is the default. Bifrost reads the confluence_relay_rollout_force_apollo dynamic config through the native
 * SDK so the early query writes to the same cache that its post-init reader uses.
 *
 * Set once on EVERY request, including failure paths, to avoid reusing another tenant's decision.
 * Only loadSessionData consumes this value; other operations use their normal routing decision.
 * Null means no pre-init decision (e.g. outside Bifrost), so isRelayEnabled handles routing.
 */
let ssrForcedRelay: boolean | null = null;

export function setSSRForcedRelay(value: boolean | null): void {
	ssrForcedRelay = value;
}

export function getSSRForcedRelay(): boolean | null {
	return ssrForcedRelay;
}

export function __TEST_ONLY_resetSSRForcedRelay(): void {
	ssrForcedRelay = null;
}
